import axios from '@/plugins/axios'
import CookieOperation from '@/plugins/cookie'
import moment from 'moment'
import {UUID} from '@/plugins/common'
function getFormData (key, file) {
  let formData = new FormData()
  // let data=this.getOssPolicyAndSignature()
  // 注意formData里append添加的键的大小写
  formData.append('key', key) // 存储在oss的文件路径
  formData.append('OSSAccessKeyId', sessionStorage.getItem('accessKeyId')) // accessKeyId
  formData.append('policy', sessionStorage.getItem('policy')) // policy
  formData.append('signature', sessionStorage.getItem('signature')) // 签名
  // 如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
  formData.append('file', file, file.name)
  formData.append('success_action_status', 200) // 成功后返回的操作码
  return formData
}

function getSuffix (fileName) {
  let pos = fileName.lastIndexOf('.')
  let suffix = ''
  if (pos !== -1) {
    suffix = fileName.substring(pos)
  }
  return suffix
}

function getOssKey (type, fileName) {
  return `ak0000000386/${CookieOperation.get('tenantId')}/${type}/${moment().format('YYYYMM')}/${UUID.create() + getSuffix(fileName)}`
}
export default {
  async install (Vue) {
    // 获取key的方式有的地方不一致，现在采取其中一种
    /*
    * @param {Object} params 配置参数
    * {
    *   type: 获取OssKey的type，默认为 USER
    *   file: 文件流
    *   url：路径
    *   key：OSSKey，如果不传，这使用默认的getOssKey方法获取key
    * }
    * @return {promise} 成功返回 {res: 接口返回的数据, key: 生成的key}
    * */
    function upload (params) {
      if (!params.url) {
        params.url = sessionStorage.getItem('ossDownloadUrl')
      }
      if (!params.key) {
        let type = params.type || 'USER'
        params.key = getOssKey(type, params.file.name)
      }
      let formData = getFormData(params.key, params.file)
      return new Promise(async (resolve, reject) => {
        await axios.post(params.url, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(res => resolve({res, key: params.key})).catch(res => reject(res))
      })
    }
    Vue.$upload = upload
    Object.defineProperties(Vue.prototype, {
      $upload: { get () { return upload } }
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/upload/index.js